enum StubHubRoutesEnum {
  //Calendar Presets
  CALENDAR_PRESETS = "global/calendar-presets",

  //Users
  USER_DETAILS = "user/details",

  //User Management
  USER_CREATE_OR_UPDATE = "user-management/create-user",
  USER_AUTH0_DETAIL = "user-management/user-auth0-details",
  USER_RESEND_INVITE = "user-management/user-resend-invite",
  USER_LIST = "user-management/user-list",
  USER_DELETE = "user-management/delete",

  //Commissions
  BROKER_TAG_DETAILS = "/stubhub/commissions/broker-tag-details",
  BROKER_TAGS_COMMISSION_UPDATE = "/stubhub/commissions/update-broker-tag-commissions",

  //Reports dashboard
  DASHBOARD_CATEGORY_LIST = "stubhub/reports/category",
  ADD_REMOVE_FAVORITES = "stubhub/reports/add-remove-favorite",

  //Filter Options
  BROKER_TAGS_BY_REPORT_ID = "stubhub/reports/broker-tags-by-report-id",
  BUYER_LIST = "stubhub/reports/buyer-details",
  SHIPPER_LIST = "stubhub/reports/shipper-details",
  EVENT_LIST = "stubhub/reports/event-details",
  VENUE_LIST = "stubhub/reports/venue-details",
  DATE_RANGE = "stubhub/reports/date-ranges",
  CARD_LIST = "stubhub/reports/card-details",
  ALERT_LIST = "stubhub/reports/alert-details",
  CURRENCY_LIST = "stubhub/reports/currency-details",
  REPORT_LIST = "stubhub/reports/report-details",
  RECIPIENT_LIST = "stubhub/reports/recipient-details",
  SALE_CATEGORY_LIST = "stubhub/reports/sale-category-details",
  CUSTOMER_CLASSIFICATION_LIST = "stubhub/reports/customer-classification-details",
  STATE_LIST = "stubhub/reports/all-states",
  INVENTORY_CANCELLATION_TYPE_LIST = "stubhub/reports/all-inventory-cancellation-types",
  SEAT_INTELLIGENCE_DETAILS = "stubhub/reports/seat-intelligence-details",
  BROKER_USER_LIST = "stubhub/reports/broker-list",
  BUYER_USER_LIST = "stubhub/reports/buyer-list",
  LISTER_USER_LIST = "stubhub/reports/lister-list",
  SEAT_MAP_CREATOR_USER_LIST = "stubhub/reports/seat-map-creator-list",
  CHECKER_USER_LIST = "stubhub/reports/checker-list",
  VENUE_DATE_PRESETS = 'stubhub/reports/venues-date-presets',
  // LISTER_USER_BY_BROKER = "stubhub/reports/lister-list-by-broker",
  BROKER_TEAM_BY_BROKER = "stubhub/reports/broker-team-by-broker-id",
  AGING_PERIODS_LIST = "stubhub/reports/get-all-aging-periods",
  FULFILLMENT_STATUSES_LIST = "stubhub/reports/get-all-fulfillment-statuses",
  SHOW_CATEGORIES = "stubhub/filters/show-categories",
  SCRAPING_STATUS_DETAILS = "stubhub/reports/scraping-status-details",
  VENUE_SCRAPING_TYPES = "/stubhub/filters/venue-scraping-type",

  // Profitability Reports
  GROSS_PROFIT = "stubhub/reports/gross-profit",
  GROSS_PROFIT_CANCELLED = "stubhub/reports/gross-profit-cancelled",
  PROFIT_DASHBOARD_SCORE = "stubhub/reports/profit-dashboard/score",
  PROFIT_DASHBOARD_BROKER_SUMMARY = "stubhub/reports/profit-dashboard/broker-summary",
  PROFIT_DASHBOARD_GROSSPROFIT_GRAPH = "stubhub/reports/profit-dashboard/grossprofit-graphdata",
  PROFIT_DASHBOARD_BROKER_COMMISSION_GRAPH = "stubhub/reports/profit-dashboard/brokercommission-graphdata",
  PROFIT_DASHBOARD_GROSSPROFIT_PERIOD_BREAKUP = "stubhub/reports/profit-dashboard/grossprofit-period-breakup",
  PROFIT_DASHBOARD_GROSSPROFIT_BROKER_COMMISSION_PERIOD_BREAKUP = "stubhub/reports/profit-dashboard/grossprofit-broker-commission-period-breakup",
  PROFIT_DASHBOARD_TOP_EVENTS = "stubhub/reports/profit-dashboard/profit-dashboard-top-events",
  BROKER_TAG_ISSUES = "stubhub/reports/broker-tags-issues",
  CONSIGNMENT_SALES = "stubhub/reports/consignment-sales",
  SHORTS_PENDING = "stubhub/reports/orders-pending-delivery",
  CONSIGNMENT_PENDING_BUY_IN = "stubhub/reports/consignment-pending-buy-in",
  INVOICES_NEEDING_ATTENTION = "stubhub/reports/invoices-needing-attention",
  RECEIVABLES_DETAILS = "stubhub/reports/gross-profit/receivables-wholesale-consignments",
  RECEIVABLES_RETAIL = "stubhub/reports/gross-profit/receivables-retail",
  RECEIVABLES_DETAILS_OLD = "stubhub/reports/gross-profit/receivables-wholesale-consignments-old",
  RECEIVABLES_RETAIL_OLD = "stubhub/reports/gross-profit/receivables-retail-old",
  ACTIVE_ZONE_LISTING = "stubhub/reports/active-zone-listing",
  OTHER_COSTS_AND_CREDITS = "stubhub/reports/gross-profit/other-costs-and-credits",

  SOLD_INVENTORY_ISSUE_RESOLUTION = "stubhub/reports/save_sold_inventory_resolve_issue",

  LONG_INVENTORY = "stubhub/reports/stubhub/inventory/long",
  LONG_INVENTORY_NOT_LISTED = "stubhub/reports/stubhub/inventory/long/not-listed",
  LONG_INVENTORY_SCORECARD = "stubhub/reports/scorecard",
  SKYBOX_USER_LIST = "stubhub/reports/skybox-user-details",
  SKYBOX_VENDORS = "stubhub/reports/skybox-vendors",
  ROLE_LIST = "stubhub/reports/role-details",
  SPLIT_TYPE_LIST = "stubhub/reports/split-type-details",
  BUYER_TAG_LIST = "stubhub/reports/buyer-tag-details",
  LISTER_TAG_LIST = "stubhub/reports/lister-tag-details",
  TICKETBASH_BROKER_LIST = "stubhub/reports/ticketbash-broker-details",
  PRICING_RESOLUTIONS = "/stubhub/reports/resolve-pricing-master",
  SAVE_PRICING_RESOLUTIONS = "/stubhub/reports/save_long_rpt_resolve_pricing_issue",

  //Schedule
  CREATE_SCHEDULE = "stubhub/scheduler/create",
  GET_SCHEDULE_LIST = "stubhub/scheduler/schedule-list",
  GET_SCHEDULE_BY_ID = "stubhub/scheduler/schedule-by-id",
  GET_SCHEDULE_RECIPIENTS = "stubhub/scheduler/recipients",
  TOGGLE_SCHEDULE_STATUS = "stubhub/scheduler/toggle-status",
  DELETE_SCHEDULE = "stubhub/scheduler/delete-schedule",
  FORCE_RUN_SCHEDULE = "stubhub/scheduler/force-run",

  
  LOG = "log",

  //Venue
  VENUE_DETAILS = "stubhub/venue/details",
  VENUE_ADD_REMOVE_FAVORITES = "stubhub/venue/add-remove-favorites",
  VENUE_EDIT = "stubhub/venue/edit",
  VENUE_BULK_ASSIGN_BROKER = "stubhub/venue/bulk-assign-venues",
  VENUE_BUYER_LIST = "stubhub/venue/buyer-list/{venue_id}",

  //Event
  EVENT_DETAILS = "stubhub/event/details",

  //Event Metadata
  EVENT_METADATA = "stubhub/event/metadata",
  EVENT_METADATA_AUDIT_HISTORY = "stubhub/event/metadata-audit-history",
  EVENT_METADATA_TREND_DATA = "stubhub/event/zone-trend",
  EVENT_METADATA_SAVE = "stubhub/event/metadata",
  EVENT_LIST_FOR_COPY_DOWN_METADATA = "stubhub/event/get-events-for-copy-down-metadata/{event_id}",
  EVENT_SAVE_COPY_DOWN_METADATA = "stubhub/event/save-copy-down-metadata/{event_id}",
  SEAT_MAP_TBD_DROPDOWN_DATA = "/stubhub/event/seat-map-tbd-dropdown-data",
  EVENT_REFRESH_MVW = "stubhub/event/refresh-mvw-for-upcoming-events",
  SPLIT_METADATA = "stubhub/event/save-split-metadata",

  //Event Create New Zone Listing
  EVENT_METADATA_FOR_NEW_ZONE_LISTING = "stubhub/event/metadata-for-create-zone-listing",

  //Housekeeping
  ACTIVE_INVENTORY = "stubhub/inventory/active",
  SOLD_INVENTORY = "stubhub/inventory/sold",
  SOLD_INVENTORY_LIST_ITEM = "stubhub/inventory/sold-item",
  UNFILLED_ZONES = "stubhub/inventory/unfilled-zones",
  UNFILLED_ZONE_LIST_ITEM = "stubhub/inventory/unfilled-zone-item/",
  CANCEL_INVENTORY = "stubhub/cancel-inventory",
  CANCEL_INVOICE = "stubhub/cancel-invoice",
  CANCELLED_INVENTORY = "stubhub/inventory/cancelled-inventory",
  VENUES_WITH_UNMAPPED_EVENT = "stubhub/event-mapping/venues",
  EVENTS_FOR_MAPPING = "stubhub/event-mapping/get-events-for-mapping",
  UPDATE_SCRAPING_EVENTS = "stubhub/event-mapping/map-events",

  //Zones
  ZONE_DETAILS_BY_ID = "stubhub/zones/zone-details-for-zone-listing",
  ZONE_CREATE_NEW_LISTING = "stubhub/zones/create-listing/{event_id}",
  ZONE_REFRESH_MVW_FOR_PURCHASE = "stubhub/zones/purchase/refresh-mvw-for-purchase",
  ZONE_LISTING_DETAILS_BY_EVENT = "/stubhub/zones/zone-listing-details-by-event",
  ZONE_ACTIVE_LISTINGS_BY_EVENT = "/stubhub/zones/active-listings-by-event",
  ZONE_FORCE_UPDATE_PURCHASE = "stubhub/zones/purchase/force-update/{purchase_id}",
  ZONE_FORCE_UPDATE_REFRESHED_MVW_CONFIG = "/stubhub/zones/update-configuration-master-refreshing-mvw-off",
  // All Zone Listings
  ZONE_ALL_ZONE_LISTINGS = "/stubhub/zones/events-with-active-zone-listings",
  HIGH_RISK_LISTINGS= "/stubhub/zones/get-high-risk-listings",
  ZONE_HIGH_RISK_LISTINGS = "/stubhub/zones/events-with-high-risk-listings",
  // Pending Fills
  ZONE_PENDING_ZONE_FILLS = "/stubhub/zones/get-pending-zone-fills-listings",
  ZONE_PAYMENT_STATUS_LIST = "/stubhub/zones/get-all-payment-statuses",
  ZONE_ACTIVE_LISTINGS_UPDATE_BROADCAST_STATUS = "/stubhub/zones/active-listings-update-broadcast-status/{inventory_id}",
  ZONE_INVENTORY_FORCE_SYNCED = "/stubhub/zones/zone-stubhub/inventory/force-synced",
  ZONE_GET_EVENTS_CREATE_LISTING_BULK_PLACEMENT = "/stubhub/zones/get-events-create-listing-bulk-placement",
  ZONE_ACTIVE_LISTING_CANCEL = "/stubhub/zones/active-listing-cancel/purchases/{purchase_id}/lines/{line_id}",
  ZONE_PENDING_ZONE_FILLS_PURCHASE_ASSIGNMENT = "/stubhub/zones/pending-fills-zone-assignment",
  ZONE_ACTIVE_LISTINGS_SPLIT_INVENTORY = "/stubhub/zones/zone-inventory/split-inventory/{inventory_id}/{numberOfTickets}",
  ZONE_PURCHASE_LINE_FORCE_SYNCED = "/stubhub/zones/purchase/line/force-update/{purchase_line_id}",
  ZONE_PENDING_ZONE_FILLS_SAVE_PURCHASE_ASSIGNMENT = "/stubhub/zones/save-purchase-assignments",
  // Split Inventory Data
  ZONE_GET_SPLIT_INVENTORY_DATA = "/stubhub/zones/get-split-inventory-data",
  // Edit Listing
  ZONE_LISTING_UPDATE_SECTION_ROW_PRICE = "/stubhub/zones/edit-listing-section-row-price",
  ZONE_FORCE_UPDATE_INVENTORIES = "/stubhub/zones/force-update-platform-skybox-inventories",
  ZONE_BULK_UPDATE_BROADCAST_STATUS = "/stubhub/zones/bulk-update-listing-broadcast-status",

  // Remap Listing with Zone
  ZONE_REMAP_LISTING_WITH_ZONE = "/stubhub/zones/remap-listings-with-zones",

  
  // Dashboard
  DASHBOARD_LISTER_ALERTS_NEW_SHOWS_COUNT = "/stubhub/dashboard/lister/alerts/new-shows-count",
  DASHBOARD_LISTER_INSIGHTS_EVENTS_COUNT = "/stubhub/dashboard/lister/insights/events-count",
  DASHBOARD_LISTER_INSIGHTS_VENUES_COUNT = "/stubhub/dashboard/lister/insights/venues-count",
  DASHBOARD_LISTER_KPIS_NEW_LISTINGS_GRAPH = "/stubhub/dashboard/lister/kpis/new-listings",
  DASHBOARD_LISTER_INSIGHTS_ZONE_LISTINGS_COUNT = "/stubhub/dashboard/lister/insights/zone-listings-count",
  DASHBOARD_LISTER_NEW_SHOWS_NO_LISTING_DATA = "/stubhub/dashboard/lister/all-events-data",
  DASHBOARD_LISTER_UN_BROADCASTS_GRAPH = "/stubhub/dashboard/lister/kpis/un-broadcasts",
  DASHBOARD_LISTER_SALES_OVER_TIME_GRAPH = "/stubhub/dashboard/lister/kpis/sales-over-time",

  DASHBOARD_CHECKER_SEAT_AVAILABILITY = "/stubhub/dashboard/checker/seat-availability",
  DASHBOARD_CHECKER_KPIS_SEAT_AVAILABILITY_UPDATE_GRAPH = "/stubhub/dashboard/checker/kpis/seat-availability-update-over-time",
  DASHBOARD_CHECKER_ALERTS_NEW_SHOWS_COUNT = "/stubhub/dashboard/checker/alerts/shows-count",

  DASHBOARD_SEAT_MAP_CREATOR_ALERTS_SHOWS_COUNT = "/stubhub/dashboard/seat-map-creator/alerts/shows-count",
  DASHBOARD_SEAT_MAP_CREATOR_SEAT_STRUCTURE_DATA = "/stubhub/dashboard/seat-map-creator/seat-structure-data",
  DASHBOARD_SEATMAP_SEATING_STRUCTURE_CREATED_GRAPH = "/stubhub/dashboard/seat-map-creator/kpis/seating-structure-created",

  DASHBOARD_OPERATIONS_ALERTS_HIGH_RISK_LISTINGS = "/stubhub/dashboard/operations/get-high-risk-listings",
  DASHBOARD_OPERATIONS_PENDING_FILLS_ALERTS_COUNTS = "/stubhub/dashboard/operations/get-pending-zone-fills-widget-counts",
  DASHBOARD_OPERATIONS_PENDING_FILLS_ALERTS_SALES = "/stubhub/dashboard/operations/get-pending-zone-fills-widget-sales",
  DASHBOARD_OPERATIONS_PENDING_FILLS_ALERTS_BROKERS = "/stubhub/dashboard/operations/get-pending-zone-fills-widget-brokers",
  DASHBOARD_BOT_PERFORMANCE_DATA = "/stubhub/bot-performance-data",
  
  DASHBOARD_PERFORMANCE_ANALYSIS_CREATED_SECTIONS = "/stubhub/dashboard/performance-analysis/created-sections",
  DASHBOARD_PERFORMANCE_ANALYSIS_CHECKED_SECTIONS = "/stubhub/dashboard/performance-analysis/checked-sections",
  DASHBOARD_PERFORMANCE_ANALYSIS_UPDATED_GA_EVENTS_SECTIONS = "/stubhub/dashboard/performance-analysis/updated-ga-events",
  DASHBOARD_PERFORMANCE_ANALYSIS_SPLIT_INFO = "/stubhub/dashboard/performance-analysis/split-count",
  DASHBOARD_PERFORMANCE_ANALYSIS_VENUE_ASSIGNMENT_INFO = "/stubhub/dashboard/performance-analysis/venue-assignment",
  DASHBOARD_PERFORMANCE_ANALYSIS_LISTED_EVENTS_INFO = "/stubhub/dashboard/performance-analysis/listed-events",
  DASHBOARD_PERFORMANCE_ANALYSIS_LISTED_SECTIONS_INFO = "/stubhub/dashboard/performance-analysis/listed-sections",
  DASHBOARD_PERFORMANCE_ANALYSIS_LISTED_GA_EVENTS_INFO = "/stubhub/dashboard/performance-analysis/listed-ga-events",
  DASHBOARD_PERFORMANCE_ANALYSIS_LISTER_CONVERSION_RATE_INFO = "/stubhub/dashboard/performance-analysis/lister-conversion-rate",
  DASHBOARD_PERFORMANCE_ANALYSIS_LISTER_MARGIN_OF_PRICING_INFO = "/stubhub/dashboard/performance-analysis/lister-margin-of-pricing",

  // Purchase Queue
  PURCHASE_QUEUE_MASTER_DATA = "/stubhub/queue/purchase/purchase-queue-master-data",
  PURCHASE_QUEUE_INVOICE_DETAIL_MODAL_DATA = "/stubhub/queue/purchase/get-invoice-detail-modal-data",
  PURCHASE_QUEUE_GET_SWIMLANE_MASTER_LIST = "/stubhub/queue/purchase/get-purchase-swimlane-master-data",
  PURCHASE_QUEUE_GET_SWIMLANE_INVOICE_LIST = "/stubhub/queue/purchase/get-purchase-swimlane-invoice-list",
  PURCHASE_QUEUE_MOVE_TO_ON_SALE = "/stubhub/queue/purchase/move-to-onsale",
  PURCHASE_QUEUE_MOVE_TO_PURCHASED = "/stubhub/queue/purchase/move-to-purchased",
  PURCHASE_QUEUE_MOVE_TO_NEED_TO_BUY = "/stubhub/queue/purchase/move-to-need-to-buy",
  PURCHASE_QUEUE_MOVE_TO_NEED_TO_BUY_LOW_PRIORITY = "/stubhub/queue/purchase/move-to-need-to-buy-low-priority",
  PURCHASE_QUEUE_MOVE_TO_ADD_NOTES = "/stubhub/queue/purchase/add-notes",
  PURCHASE_QUEUE_CHANGE_BUYER = "/stubhub/queue/purchase/change-buyer",
  PURCHASE_QUEUE_MOVE_TO_ISSUES = "/stubhub/queue/purchase/move-to-issues",
  PURCHASE_QUEUE_GET_KEBAB_MENU_OPTIONS = "/stubhub/queue/purchase/get-purchase-queue-menu-options",
  PURCHASE_QUEUE_CHANGE_PRIORITY = "/stubhub/queue/purchase/change-priority",
  PURCHASE_QUEUE_MOVE_TO_SHIPPING = "/stubhub/queue/purchase/move-to-shipping",
  PURCHASE_QUEUE_GET_AUDIT_HISTORY = "/stubhub/queue/purchase/audit-history/{invoice_id}",
  PURCHASE_QUEUE_GET_NOTES_HISTORY = "/stubhub/queue/purchase/notes-history/{invoice_id}",
  PURCHASE_QUEUE_SAVE_ISSUE_REMINDER = "/stubhub/queue/purchase/set-issue-reminder",
  PURCHASE_QUEUE_UPDATE_ISSUE = "/stubhub/queue/purchase/update-issue",
  PURCHASE_QUEUE_CLOSE_ISSUE = "/stubhub/queue/purchase/close-issue",
  PURCHASE_QUEUE_CHANGE_ONSALE_STATUS = "/stubhub/queue/purchase/change-onsale-status",
  PURCHASE_QUEUE_SAVE_ONSALE_REMINDER = "/stubhub/queue/purchase/set-onsale-reminder",

  //Shipping Queue
  SHIPPING_QUEUE_MOVE_TO_ISSUES = "/stubhub/queue/shipping/move-to-issues",
  SHIPPING_QUEUE_CLOSE_ISSUE = "/stubhub/queue/shipping/close-issue",
  SHIPPING_QUEUE_MOVE_TO_ADD_NOTES = "/stubhub/queue/shipping/add-notes",
  SHIPPING_QUEUE_CHANGE_SHIPPER = "/stubhub/queue/shipping/change-shipper",
  SHIPPING_QUEUE_UPDATE_ISSUE = "/stubhub/queue/shipping/update-issue",
  SHIPPING_QUEUE_MARK_AS_DELIVERED = "/stubhub/queue/shipping/mark-as-delivered",
  SHIPPING_QUEUE_MARK_AS_NOT_DELIVERED = "/stubhub/queue/shipping/mark-as-not-delivered",
  SHIPPING_QUEUE_MOVE_TO_SELL_OUT = "/stubhub/queue/shipping/move-to-sell-out",
  DELIVERED_TICKETS = "/stubhub/delivered-tickets",

  //Competitor Prices
  COMPETITOR_PRICES = "/stubhub/competitor-prices",
  SECONDARY_MARKETPLACE_MASTER = "/stubhub/competitor-prices/secondary-marketplace-master",
}

export { StubHubRoutesEnum };
